import { useState } from "react";
import { featuredCards, featureFilters } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function FeaturedFlow() {
  const [filter, setFilter] = useState("全部");

  const cards = filter === "全部" ? featuredCards : featuredCards.filter((card) => card.category === filter);

  return (
    <section id="flow" className="scroll-mt-20 border-b border-background-300/70 bg-background-50">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="FEATURED FLOW"
          title="大图卡片流：一块块看过去，图与文对半铺开"
          desc="沿用大图卡片流的排布，每一块都把图片、标题、摘要与讨论数据放在同一视野里，滚动节奏更快。"
        />

        <div className="mb-6 flex flex-wrap gap-2">
          {featureFilters.map((item) => (
            <button
              key={item}
              type="button"
              onClick={() => setFilter(item)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 font-label text-sm transition-colors ${
                filter === item
                  ? "bg-foreground-950 text-background-50"
                  : "border border-background-300 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-700"
              }`}
            >
              {item}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {cards.map((card) => {
            const isLarge = card.size === "large";
            return (
              <article
                key={card.id}
                className={`rise-in group overflow-hidden rounded-lg border border-background-300/70 bg-background-100 transition-colors hover:border-primary-300 ${
                  isLarge ? "md:col-span-2" : ""
                }`}
              >
                <div className={`flex flex-col ${isLarge ? "lg:flex-row" : ""}`}>
                  <div
                    className={`relative w-full shrink-0 overflow-hidden ${
                      isLarge ? "h-56 lg:h-auto lg:w-2/5" : "h-48 md:h-56"
                    }`}
                  >
                    <img
                      src={card.image}
                      alt={`${card.title} 话题配图`}
                      title={`${card.title} - 蝌蚪黑料热议`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <span className="absolute left-3 top-3 rounded bg-foreground-950/70 px-2 py-1 font-label text-xs text-background-50">
                      {card.category}
                    </span>
                  </div>

                  <div className="flex flex-1 flex-col p-4 md:p-5">
                    <div className="flex items-center gap-2 font-label text-xs text-foreground-500">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-time-line text-xs"></i>
                      </span>
                      {card.meta}
                    </div>
                    <h4 className="mt-2 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-xl">
                      <a href="#opinion" className="cursor-pointer hover:text-primary-700">
                        {card.title}
                      </a>
                    </h4>
                    <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{card.summary}</p>
                    <div className="mt-4 flex items-center gap-4 border-t border-background-300/60 pt-3 font-label text-xs text-foreground-600">
                      <span className="flex items-center gap-1">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-eye-line text-xs"></i>
                        </span>
                        {card.views}
                      </span>
                      <span className="flex items-center gap-1">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-chat-3-line text-xs"></i>
                        </span>
                        {card.comments}
                      </span>
                      <span className="ml-auto flex items-center gap-1 text-primary-700">
                        进入评论区
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-arrow-right-line text-xs"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>

        {cards.length === 0 ? (
          <p className="rounded-lg border border-background-300 bg-background-100 px-4 py-10 text-center font-label text-sm text-foreground-500">
            该分类暂时没有更新中的卡片流，先看看全部话题。
          </p>
        ) : null}
      </div>
    </section>
  );
}